module.exports = __webpack_public_path__ + "img/portrait.09f4ee99.jpg";